import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-notifications1-icon',
  templateUrl: './general-notifications1.component.html'
})
export class GeneralNotifications1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
